import React, { memo } from 'react';
export function Footer() {
  return <footer className="bg-navy py-12 px-4 border-t-4 border-orange text-center" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-white mb-4" data-id="element-74">
          🧠 FOCUSED MINDSET™
        </h2>
        <p className="text-white/90 text-base md:text-lg mb-2 font-medium" data-id="element-75">
          The done-for-you brain training system for parents who want their
          child to build real focus, memory, and self-control — without screens,
          without arguments, and without spending hours planning.
        </p>
        <p className="text-orange font-bold italic mb-8 text-lg" data-id="element-76">
          Because raising a focused, confident child should not cost you years
          of trial and error.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-white/70 text-sm mb-8 font-medium bg-black/20 py-3 px-6 rounded-full inline-flex border border-white/10" data-id="element-77">
          <span data-id="element-78">🌐 www.eurekalabs.store</span>
        </div>

        <p className="text-white/40 text-xs mb-8" data-id="element-79">
          © 2026 EurekaLabs.store™ — All Rights Reserved.
        </p>

        <p className="text-lg md:text-xl text-white font-heading font-bold leading-relaxed" data-id="element-80">
          "Your child's brain is developing every single second. The question is
          not whether they are being trained. The question is what they are
          being trained for." 🧠
        </p>
      </div>
    </footer>;
}